import React, {
  useState,
  useEffect,
} from "react";
import { useNavigate } from "react-router-dom";
import { Button, Drawer, Stack, Typography } from "@mui/material";

import { APIs_GetScenarioInputs, API_Client } from "./api.jsx";
import { SliderLabelled, SliderCPP, SliderOAS } from "../Components/Inputs/Sliders.jsx";
import { useClient } from "./useClient.jsx";
import { CrumbToggleScenario } from "../Components/CrumbToggles.jsx";
import {
  getOptions,
  postOptions,
  empty_uuid,
  ftchPlus,
  scenOptionClient,
} from "./Account_urls.jsx";
import { ScenarioUrl_post } from "./Account_urls.jsx";
import { Input_label } from "../Components/Inputs/Input_Name.jsx";
import { InputPercentageInflation } from "../Components/Inputs/Input_Percentage.jsx";
import { errorCheckForm, errorClear, errorJsonHasErrors, errorSet } from "../Components/Inputs/Input_Fns.jsx";
import { ErrorBar } from "../Components/ErrorBar.jsx";
import { Help_RunScenario } from "../Dialogs/Help/Help_Inputs.jsx";
import { GoogleAnalyticsEvent } from "../Components/ga4.jsx";
import { TopOffset } from "./Navbar_bs.jsx";


const RunScenarioInput = ({ show, onClose, clientJson, c_callback }) => {
  const navigate = useNavigate();
  const { setclient_ } = useClient();
  const [clients, setClients] = useState([]);
  const [errors, setErrors] = useState({})
  const [errmsg, setErrmsg] = useState("")
  const [enabled, setEnabled] = useState(false)

  const [scenBasic, setScenBasic] = useState({
    parent: 0,
    startReport: 0,
    startCalc: 0,
    start_min: 18,
    start_max: 99,
    round: 100,
    uuid: empty_uuid,
    inflationRate: 2.3,
  });
  const [scenClient, setScenClient] = useState();
  // const [scenClient, setScenClient] = useState({
  //   uuid: empty_uuid,
  //   name: "",
  //   die_age: 95,
  //   cpp_age: 65,
  //   cpp_max: 70,
  //   oas_age: 65,
  // });
  const [scenSpouse, setScenSpouse] = useState({
    uuid: empty_uuid,
    name: "",
    die_age: 95,
    cpp_age: 65,
    cpp_max: 70,
    oas_age: 65,
  });

  const clear = () => {
    setScenBasic({
      label: "",
      startReport: 0,
      startCalc: 0,
      start_min: 0,
      start_max: 0,
      round: 0,
      uuid: empty_uuid,
      inflationRate: 0,
    });

    setScenClient({
      uuid: empty_uuid,
      name: "",
      die_age: 0,
      cpp_age: 0,
      cpp_max: 70,
      oas_age: 0,
    });

    setScenSpouse({
      uuid: empty_uuid,
      name: "",
      die_age: 0,
      cpp_age: 0,
      cpp_max: 70,
      oas_age: 0,
    });
  };

  const onSubmit = (e) => {
    errorCheckForm()
    if (!errorJsonHasErrors(errors)) {
      postRequest();
    }
  };

  const postRequest = async () => {
    console.log(clientJson);
    console.log(scenBasic);

    const post = {
      uuid: clientJson.Scenario.uuid,
      type: "scenario",
      label:
        clientJson.Scenario.uuid !== empty_uuid
          ? clientJson.Scenario.label
          : scenBasic.label,
      startReport: scenBasic.startReport,
      inflation_rate: Number(scenBasic.inflationRate),
      startCalc: scenBasic.startCalc,
      person: [
        {
          uuid: clientJson.uuid,
          die_age: scenClient.die_age,
          cpp_age: scenClient.cpp_age,
          oas_age: scenClient.oas_age,
        },
      ],
    };
    if (scenSpouse.uuid !== empty_uuid) {
      const sp = {
        die_age: scenSpouse.die_age,
        cpp_age: scenSpouse.cpp_age,
        oas_age: scenSpouse.oas_age,
      };
      post.person.push(sp);
    }
    GoogleAnalyticsEvent("perform", "run", "scenario", { action: "run", type: "scenario" })

    var url = ScenarioUrl_post(clientJson);
    var req = postOptions;
    req.body = JSON.stringify(post);
    ftchPlus(url, req)
      .then((json) => {
        console.log(json.uuid);
        console.log(json.label);
        console.log(clientJson);
        let sc = {
          ...clientJson.Scenario,
          uuid: json.uuid,
          label: json.label,
        };
        let jc = { ...clientJson, Scenario: sc };
        // let bc = [
        //   <Link underline="hover" key={response.Uuid} href="/scenarioSelect">
        //     {response.Uuid}
        //   </Link>,
        // ];
        // console.log(bc);
        // let crumb = [];
        // if (jc.Breadcrumbs !== undefined) {
        //   crumb = jc.Breadcrumbs;
        // }
        // crumb.push(bc);
        // console.log(bc);
        // jc = { ...jc, Breadcrumbs: crumb };
        console.log(jc);
        setclient_(jc);
        c_callback(jc);
        setEnabled(false)
        onClose();
        navigate("/gridScenario");
      })
      .catch((error) => {
        console.log(error.message);
        setErrmsg(error.message)

      });
  };

  const getInputData = () => {
    setEnabled(false)
    console.log("Get Scenario");
    console.log(clientJson);
    var url =
      API_Client +
      clientJson.uuid +
      APIs_GetScenarioInputs +
      scenOptionClient(clientJson);

    ftchPlus(url, getOptions)
      .then((json) => {
        if (json) {
          let cs = [];
          setScenBasic({
            ...scenBasic,
            uuid: clientJson.uuid,
            label:
              clientJson.Scenario.uuid !== empty_uuid
                ? clientJson.Scenario.label
                : "",
            startReport: json.startReport,
            start_min: json.start_min,
            start_max: json.start_max,
            startCalc: json.startCalc,
            birthYear: json.birthYear,
            round: json.round,
            inflationRate: json.inflation_rate,
          });
          if (json.person[0]) {
            setScenClient({
              ...scenClient,
              die_age: json.person[0].die_age,
              cpp_age: json.person[0].cpp_age,
              cpp_max: json.person[0].cpp_max,
              oas_age: json.person[0].oas_age,
            });
            cs.push(json.person[0].name);
          }
          if (json.person[1]) {
            setScenSpouse({
              ...scenSpouse,
              uuid: json.person[1].uuid,
              name: json.person[1].name,
              die_age: json.person[1].die_age,
              cpp_age: json.person[1].cpp_age,
              cpp_max: json.person[1].cpp_max,
              oas_age: json.person[1].oas_age,
            });
            cs.push(json.person[1].name);
          }
          setClients(cs);
          setEnabled(true)
        }
      })
      .catch((error) => {
        console.log(error.message);
        setErrmsg(error.message)
      });
  };

  useEffect(() => {
    console.log("overlay");
    setEnabled(false)
    if (show) {
      errorClear(errors)
      setErrmsg("")
      getInputData();
    } else {
      console.log("RSI: clear");
      errorClear(errors)
      setErrmsg("")
      clear();
    }
  }, [show]);

  useEffect(() => { }, [scenBasic, scenClient, scenSpouse]);

  const b_Change = (e) => {
    setScenBasic({
      ...scenBasic,
      [e.target.name]: e.target.value,
    });
  };
  const i_Change = (e) => {
    let value = parseFloat(e.target.value);
    setScenBasic({
      ...scenBasic,
      [e.target.name]: value,
    });
  };

  const c_Change = (e) => {
    console.log(e.target);
    let value = parseInt(e.target.value);
    let min = parseInt(e.target.min);
    let max = parseInt(e.target.max);
    setScenClient({
      ...scenClient,
      [e.target.name]: value,
    });
  };
  const cs_Change = (e) => {
    // console.log(e.target);
    setScenClient({
      ...scenClient,
      [e.target.name]: e.target.value,
    });
  };
  const ss_Change = (e) => {
    // console.log(e.target);

    setScenSpouse({
      ...scenSpouse,
      [e.target.name]: e.target.value,
    });
  };

  const getStartReportMarks = () => {
    let marks = [
      { label: scenBasic.start_min, value: scenBasic.start_min },
      { label: scenBasic.start_max, value: scenBasic.start_max },
    ];

    return marks;
  };

  const getStartCalcMarks = () => {
    let marks = [
      { label: scenBasic.start_min + 1, value: scenBasic.start_min + 1 },
      { label: scenBasic.start_max + 1, value: scenBasic.start_max + 1 },
    ];

    return marks;
  };

  const getSlider_startReport = () => {
    return "StartReport Age (" + scenBasic.startReport + ")";
  };
  const getSlider_startCalc = () => {
    return "StartCalculation Age (" + scenBasic.startCalc + ")";
  };

  const getRun_label = () => {
    if (clientJson.Scenario.uuid !== empty_uuid) {
      return "Re-Run Scenario : " + clientJson.Scenario.label;
    }
    return "Run New Scenario";
  };

  return (
    <>
      {show && scenClient !== undefined && (
        <Drawer sx={{}} placement="left" open={show} onClose={onClose}>
          <Stack sx={{ mx: 6, mt: TopOffset }} spacing={2}>
            <CrumbToggleScenario
              current=""
              set={clients}
              clientJson={clientJson}
              onChange={() => { }}
              crumbClose={(json) => {
                c_callback(json);
                onClose();
              }}
            />

            <Stack sx={{ px: 2 }} spacing={2}>
              <Stack sx={{ mt: 10 }} direction="row" spacing={2}>

                <Button
                  onClick={onSubmit}
                  variant="contained"
                  disabled={!enabled}
                  sx={{ minWidth: 150, textTransform: "none", mb: 4 }}
                >
                  {getRun_label()}
                </Button>
              </Stack>
              <Stack sx={{ pt: 2 }} spacing={2}>
                <Input_label
                  disabled={clientJson.Scenario.uuid !== empty_uuid}
                  value={scenBasic.label}
                  onChange={b_Change}
                  onError={(e) => errorSet(errors, setErrors, "label", 0, e)}
                />
                <InputPercentageInflation
                  name="inflationRate"
                  percent={scenBasic.inflationRate}
                  onChange={b_Change}
                />
                <SliderLabelled
                  label={"Start Report @ " + clientJson.name + "'s Age"}
                  name="startReport"
                  min={scenBasic.start_min}
                  max={scenBasic.start_max}
                  value={scenBasic.startReport}
                  birthYear={scenBasic.birthYear}
                  onChange={b_Change}
                />
                <SliderLabelled
                  label={"Start Computation @ " + clientJson.name + "'s Age"}
                  name="startCalc"
                  min={scenBasic.start_min + 1}
                  max={scenBasic.start_max + 1}
                  value={scenBasic.startCalc}
                  birthYear={scenBasic.birthYear}
                  onChange={b_Change}
                />


                <Typography
                  sx={{ pt: 5 }}
                  id="die-age-slider"
                  className="mt-2"
                  variant="h6"
                  gutterBottom
                >
                  {clientJson && clientJson.name ? clientJson.name : ""}
                </Typography>

                <Stack spacing={2}>
                  <SliderLabelled
                    label="Life Expectancy"
                    name="die_age"
                    value={scenClient.die_age}
                    onChange={cs_Change}
                    min="50"
                    max="120"
                  />
                  <SliderCPP
                    name="cpp_age"
                    value={scenClient.cpp_age}
                    onChange={cs_Change}
                    maxAge={scenClient.cpp_max}
                  />
                  <SliderOAS
                    name="oas_age"
                    value={scenClient.oas_age}
                    onChange={cs_Change}
                  />
                </Stack>
                {scenSpouse.uuid !== empty_uuid && (
                  <>
                    <Typography sx={{ pt: 5 }} id="s-die-age-slider" variant="h6" gutterBottom>
                      {scenSpouse.name}
                    </Typography>
                    <Stack>
                      <SliderLabelled
                        label="Life Expectancy"
                        name="die_age"
                        value={scenSpouse.die_age}
                        onChange={ss_Change}
                        min="50"
                        max="120"
                      />
                      <SliderCPP
                        name="cpp_age"
                        value={scenSpouse.cpp_age}
                        onChange={ss_Change}
                        maxAge={scenSpouse.cpp_max}
                      />
                      <SliderOAS
                        name="oas_age"
                        value={scenSpouse.oas_age}
                        onChange={ss_Change}
                      />
                    </Stack>
                  </>
                )}
              </Stack>
            </Stack>
          </Stack>
          <Help_RunScenario />
          <ErrorBar error={errmsg} />
        </Drawer>
      )}
    </>
  );
};

export default RunScenarioInput;
